import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import Reveal from "../components/Reveal";
import { useSite } from "../context/SiteContext";

export const Gallery = ({ standalone = false }) => {
    const { content } = useSite();
    const list = content.gallery || [];
    const [open, setOpen] = useState(null);

    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className={`relative bg-white ${standalone ? "pt-36 pb-28" : "py-24 lg:py-32"}`}
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 mb-14">
                    <Reveal className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#14545E]/10 text-[#14545E] text-[11px] tracking-[0.2em] uppercase mb-5">
                            Qalereya
                        </div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A1F3D] leading-[1.05]">
                            Akademiyamızdan anlar.
                        </h2>
                    </Reveal>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
                    {list.map((g, i) => {
                        const tall = i % 5 === 0 || i % 5 === 3;
                        return (
                            <Reveal key={g.id || i} delay={i * 0.04}>
                                <button
                                    type="button"
                                    onClick={() => setOpen(g)}
                                    data-testid={`gallery-item-${i}`}
                                    className={`relative w-full overflow-hidden group rounded-2xl border border-neutral-200 ${tall ? "lg:row-span-2 aspect-[3/4]" : "aspect-square"}`}
                                >
                                    <img
                                        src={g.url}
                                        alt={g.caption || `KA Academy ${i + 1}`}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-[#0A1F3D]/0 group-hover:bg-[#0A1F3D]/30 transition-colors" />
                                    {g.caption && (
                                        <div className="absolute bottom-0 left-0 right-0 px-4 py-3 bg-gradient-to-t from-black/70 to-transparent text-white text-xs text-left opacity-0 group-hover:opacity-100 transition-opacity">
                                            {g.caption}
                                        </div>
                                    )}
                                </button>
                            </Reveal>
                        );
                    })}
                </div>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setOpen(null)}
                        className="fixed inset-0 z-[100] bg-[#0A1F3D]/95 flex items-center justify-center p-6"
                    >
                        <button
                            onClick={() => setOpen(null)}
                            className="absolute top-6 right-6 text-white hover:text-[#7FB8C6] p-2"
                            data-testid="lightbox-close"
                            aria-label="Bağla"
                        >
                            <X size={28} />
                        </button>
                        <motion.img
                            initial={{ scale: 0.95, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.95, opacity: 0 }}
                            src={open.url}
                            alt={open.caption}
                            className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg"
                            onClick={(e) => e.stopPropagation()}
                        />
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};

export default Gallery;
